/** Homepage / ICM 3.0 images on CDN via ICM_IMAGES_URL_V3 */
const ICM_3_0_IMG = process.env.ICM_IMAGES_URL_V3;

export const HomepageAssets = {
    phone: `${ICM_3_0_IMG}webp/phone.webp`,
    portfolio: `${ICM_3_0_IMG}webp/portfolio.webp`,
    appleStore: `${ICM_3_0_IMG}webp/apple-store.webp`,
    playStore: `${ICM_3_0_IMG}webp/play-store.webp`,
    growWealthMobile: `${ICM_3_0_IMG}webp/grow-wealth-mobile.webp`,
    qrCode: `${ICM_3_0_IMG}webp/qr-code.webp`,
    floatingAppStore: `${ICM_3_0_IMG}webp/floating-app-store.webp`,
    floatingPlayStore: `${ICM_3_0_IMG}webp/floating-play-store.webp`,
    avatarNidhi: `${ICM_3_0_IMG}webp/avatar-nidhi.webp`,
    avatarMale: `${ICM_3_0_IMG}webp/avatar-male.webp`,
    ipoAcko: `${ICM_3_0_IMG}webp/acko.webp`,
    ipoRelianceJio: `${ICM_3_0_IMG}webp/reliance-jio.webp`,

    stocks: `${ICM_3_0_IMG}gif/stocks.gif`,
    globalStocks: `${ICM_3_0_IMG}gif/global-stocks.gif`,
    digitalGold: `${ICM_3_0_IMG}gif/digital-gold.gif`,
    fno: `${ICM_3_0_IMG}gif/fno.gif`,
    fd: `${ICM_3_0_IMG}gif/fd.gif`,
    ipo: `${ICM_3_0_IMG}gif/ipo.gif`,
} as const;
